export default [
  {
    path: "/partners",
    name: "Partners",
    component: () => import("../../views/Partners/PartnerList")
  },
  {
    path: "/partners/view/:uuid",
    name: "PartnerView",
    props: true,
    component: () => import("../../views/Partners/PartnerView")
  },
  {
    path: "/partner/new",
    name: "PartnerNew",
    component: () => import("../../views/Partners/PartnerNew")
  },
  {
    path: "/partner/edit/:uuid",
    name: "PartnerEdit",
    props: true,
    component: () => import("../../views/Partners/PartnerEdit")
  }
];
